import { Box, SxProps } from "@outschool/backpack";
import React from "react";

type FilterListProps = {
  children: React.ReactNode;
};

type FilterProps = {
  showTopBorder?: boolean;
  usePadding?: boolean;
  sectionTitle?: string;
  sx?: SxProps;
  children: React.ReactNode;
  largeTitle?: boolean;
};

export const FilterList = React.forwardRef<typeof Box, FilterListProps>(
  ({ children }, ref) => {
    return (
      <Box
        ref={ref}
        sx={{
          gridTemplateColumns: "1fr",
          fontSize: "1em",
        }}
      >
        {children}
      </Box>
    );
  },
);

export function Filter({
  showTopBorder = true,
  usePadding = true,
  sectionTitle = "",
  sx = {},
  children,
  largeTitle = false,
}: FilterProps) {
  return (
    <Box
      sx={[
        {
          display: "grid",
          gridTemplateColumns: "1fr",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {!!showTopBorder && (
        <Box
          sx={{
            height: "1px",
            borderTop: "1px solid #DDDFE3",
            width: "100%",
            margin: "auto",
          }}
        ></Box>
      )}
      {!!sectionTitle && (
        <Box
          sx={{
            marginTop: "2em",
            fontWeight: "fontWeightMedium",
            fontSize: largeTitle ? "1.2em" : "",
          }}
        >
          {sectionTitle}
        </Box>
      )}
      <Box
        sx={{
          paddingTop: usePadding && "0.5em",
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
